import React from "react";

import { Controller } from "@dblimp/core";
import type { ControllerProps } from "@dblimp/core";

import rootTemplate from "../schemas/definitions/root-template.json";

export interface RootProps extends ControllerProps {}

/**
 * Controller raíz: layout global del sitio.
 *
 * El `content` llega desde `src/schemas/root-schema.json` (definición
 * `rootTemplate`): header + <main> + footer. El nodo `mbMain` recibe las rutas
 * hijas mediante `childrenIn`, que es donde react-router inyecta el `<Outlet/>`.
 *
 * ⚠️ No usar `tag = false` aquí: `Container` mide su nodo con un ResizeSensor
 * para detectar el breakpoint y, sin elemento DOM, nunca resuelve
 * `breakpoint` → la vista queda en el spinner para siempre.
 */
export default class RootController extends Controller<RootProps> {
  static readonly jsClass = "RootController";

  /**
   * Template base del layout.
   *
   * `view` DEBE ser un **array de nodos** (o un nodo con `name` string): si se
   * pasa un objeto sin `name`, `JsonRender.buildContent()` lo trata como un mapa
   * de secciones y expande el array en claves `0,1,2…` → renderiza un
   * `<Component>` vacío. Ver `containers/json-render-container.tsx`
   * (`evalTemplate`).
   *
   * El nodo `mbMain` recibe las rutas hijas (`<Outlet/>`) vía `childrenIn`.
   */
  static template: any = {
    view: rootTemplate,
  };

  constructor(props: RootProps) {
    super(props);
    // Nodo real para que el ResizeSensor pueda medir el layout
    (this as unknown as { tag: string }).tag = "div";
  }

  /** Nodo del template que recibe las rutas hijas (`<Outlet/>`). */
  get childrenIn(): string {
    return "mbMain";
  }

  get fixedProps(): RootProps {
    return {
      ...this.props,
      childrenIn: this.childrenIn,
    };
  }
}
